"use client"

import RiLayoutGridFill from '~icons/ri/layout-grid-fill'
import RiMenuFill from '~icons/ri/menu-fill'
import RiSearchLine from '~icons/ri/search-line'
import RiArrowDownSLine from '~icons/ri/arrow-down-s-line'
import { useState } from 'react';
import classNames from 'classnames';
import { ibm } from '@/utils/fonts/fonts'

enum ReviewScore {
  Any = 'All',
  Masterpiece = 'Шедевр',
  Good = 'Советую',
  Beer = 'Под пиво',
  Badly = 'Так себе',
  Terrible = 'Ужасно'
}

export default function GameSearch(
  {onSearchScoreChanges, onSearchQChanges, onGenresChanges, onDisplayTypeChanges, onAutoScrollChanges}:
  {onSearchScoreChanges: Function, onSearchQChanges: Function, onGenresChanges: Function, onDisplayTypeChanges: Function, onAutoScrollChanges: Function}) {
  const genres: string[][] = [
    ['Action', 'FPS', 'Racing', 'Platformer', 'Fighting/Brawler', "Beat 'em up", "Shoot 'em up", 'Bullet Hell'],
    ['Adventure', 'Visual Novel', 'Metroidvania', 'Stealth', 'Horror'],
    ['RPG', 'Strategy', 'Tower Defense', 'Survival', 'Sandbox', 'Roguelike', 'Vampire-like'],
    ['Simulator', 'Rhythm', 'Casual', 'Puzzle', 'Coop', 'Online']
  ];

  const [isGenresPanelShow, setGenresPanel] = useState(false);
  const [isAutoScrollEnabled, setAutoScroll] = useState<boolean>(false);
  const [selectedScore, setSelectedScore] = useState(ReviewScore.Any);
  const [selectedGenres, setSelectedGenres] = useState<string[]>([]);
  const [selectedReviewsDisplay, setSelectedReviewsDisplay] = useState('block');
  const [searchQ, setSearchQ] = useState('');

  const selectScoreHandler = (reviewScore: ReviewScore) => {
    if (selectedScore !== reviewScore) {
      setSelectedScore(reviewScore);
      onSearchScoreChanges(reviewScore);
    } else {
      setSelectedScore(ReviewScore.Any);
      onSearchScoreChanges(ReviewScore.Any);
    }
  }

  const selectQHandler = (q: string) => {
    setSearchQ(q);
    onSearchQChanges(q);
  }

  const selectedReviewsDisplayHandler = (type: string) => {
    setSelectedReviewsDisplay(type);
    onDisplayTypeChanges(type);
  }

  const selectGenreHandler = (genre: string) => {
    if (!selectedGenres.includes(genre)) {
      let newGenresArray: string[] = [...selectedGenres];
      newGenresArray.push(genre);

      setSelectedGenres(newGenresArray);
      onGenresChanges(newGenresArray)
    } else {
      let newGenresArray: string[] = selectedGenres.filter(item => item !== genre);

      setSelectedGenres(newGenresArray);
      onGenresChanges(newGenresArray)
    }
  }

  const resetGenres = () => {
    setSelectedGenres([]);
    onGenresChanges([])
  }

  const selectAutoScrollStatusHandler = () => {
    if (isAutoScrollEnabled) {
      setAutoScroll(false);
      onAutoScrollChanges(false);
    } else {
      setAutoScroll(true);
      onAutoScrollChanges(true);
    }
  }
  
  return (
    <section style={ibm.style} className='flex flex-col gap-3 items-end'>
      <section className='flex flex-row flex-wrap gap-3 text-sm w-full'>
        <div className='h-14 md:h-16 bg-[#0B0B0B] px-6 py-3 rounded-full flex flex-row gap-3 items-center grow'>
          <RiSearchLine className='ml-3'/>
          <input
            placeholder='Название игры...'
            type='search'
            value={searchQ}
            onChange={e => selectQHandler(e.target.value)}
            className='bg-transparent py-2 pr-3 border-none outline-none w-full'
          />
        </div>
        <section className='h-14 md:h-16 bg-[#0B0B0B] px-4 py-3 md:py-3 rounded-full gap-1 flex flex-row w-full md:w-fit justify-between text-base'>
          <button
            onClick={() => selectScoreHandler(ReviewScore.Masterpiece)}
            className={classNames('hover:bg-zinc-800 rounded-full px-5 transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedScore === ReviewScore.Masterpiece})}>🔥</button>
          <button
            onClick={() => selectScoreHandler(ReviewScore.Good)}
            className={classNames('hover:bg-zinc-800 rounded-full px-5 transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedScore === ReviewScore.Good})}>👍</button>
          <button
            onClick={() => selectScoreHandler(ReviewScore.Beer)}
            className={classNames('hover:bg-zinc-800 rounded-full px-5 transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedScore === ReviewScore.Beer})}>🍺</button>
          <button
            onClick={() => selectScoreHandler(ReviewScore.Badly)}
            className={classNames('hover:bg-zinc-800 rounded-full px-5 transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedScore === ReviewScore.Badly})}>😐</button>
          <button
            onClick={() => selectScoreHandler(ReviewScore.Terrible)}
            className={classNames('hover:bg-zinc-800 rounded-full py-0 px-4 transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedScore === ReviewScore.Terrible})}>👎</button>
        </section>
        {/* <div className='bg-[#0B0B0B] px-4 py-3 rounded-full gap-1 flex flex-row'>
          <button
            onClick={() => selectedReviewsDisplayHandler('block')}
            className={classNames('hover:bg-zinc-800 rounded-full py-2 px-4', {'bg-zinc-800': selectedReviewsDisplay === 'block'})}><RiLayoutGridFill/></button>
          <button
            onClick={() => selectedReviewsDisplayHandler('flex')}
            className={classNames('hover:bg-zinc-800 rounded-full py-2 px-4', {'bg-zinc-800': selectedReviewsDisplay === 'flex'})}><RiMenuFill/></button>
        </div> */}
        {/* <button
          onClick={() => selectAutoScrollStatusHandler()}
          className={classNames('h-14 md:h-16 bg-[#0B0B0B] px-6 py-3 gap-3 flex flex-row items-center rounded-full justify-center grow md:grow-0')}>
          {isAutoScrollEnabled ? <RiCheckboxFill className='text-lg'/> : <RiCheckboxBlankLine className='text-lg'/>} Авто-прокрутка
        </button> */}
        <button
          onClick={() => setGenresPanel(!isGenresPanelShow)}
          className={classNames('h-14 md:h-16 bg-[#0B0B0B] px-6 py-3 gap-3 flex flex-row items-center rounded-full justify-between grow md:grow-0')}>
          Жанры <RiArrowDownSLine className={classNames('transition-transform duration-200 ease-in-out', {'rotate-180': isGenresPanelShow})}/>
        </button>
      </section>
      {!isGenresPanelShow ? '' :
        <section className='bg-[#0B0B0B] px-3 py-3 rounded-xl flex flex-col w-full gap-3'>
          <section className='gap-1 grid grid-cols-2 md:flex md:flex-row md:flex-wrap justify-between w-full'>
            {genres.map((genreArr, index) =>
              <section
                key={index}
                className='flex flex-col gap-1 my-3 md:my-0'>
                {genreArr.map((genre, genreIndex) =>
                  <button
                  onClick={() => selectGenreHandler(genre)}
                  key={genreIndex + index}
                  className={classNames('md:hover:bg-zinc-800 rounded-full py-1 px-4 w-fit transition-all duration-200 ease-in-out', {'bg-zinc-800': selectedGenres.includes(genre)})}>
                    {genre}
                  </button>
                )}
              </section>
            )}
          </section>
            <button onClick={() => resetGenres()} className='py-2 m-3 md:my-1 md:mx-3 bg-[#151515]/80 md:hover:bg-zinc-800 rounded-full transition-all duration-200 ease-in-out'>Сбросить фильтр жанров</button>
        </section>
      }
    </section>
  )
}